import * as React from 'react'

function SvgMeilisearchLogo({ title, titleId, ...props }) {
  return (
    <svg
      viewBox="0 0 76 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14.869 19.8C19.283 9.4 31.292 4.548 41.692 8.963l14.603 6.198c10.4 4.415 15.251 16.424 10.837 26.823l-6.199 14.603c-4.414 10.4-16.423 15.251-26.822 10.837l-14.604-6.198C9.108 56.81 4.257 44.802 8.67 34.403L14.87 19.8z"
        fill="url(#meilisearch_logo_svg__paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.34 48.584c-3.126-7.366-4.69-11.05-4.785-14.461a18.065 18.065 0 015.42-13.412c2.438-2.388 6.121-3.952 13.487-7.078 7.367-3.127 11.05-4.69 14.462-4.786a18.065 18.065 0 0113.412 5.419c2.388 2.438 3.951 6.122 7.078 13.488 3.127 7.366 4.69 11.05 4.785 14.461a18.065 18.065 0 01-5.418 13.412c-2.439 2.388-6.122 3.952-13.488 7.078-7.367 3.127-11.05 4.69-14.462 4.786a18.065 18.065 0 01-13.412-5.419c-2.388-2.438-3.951-6.122-7.078-13.488z"
        fill="url(#meilisearch_logo_svg__paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.093 28c4.718 0 8.216 3.457 8.216 9.07v11.266h-6.63V38.127c0-2.806-1.342-4.148-3.538-4.148-1.017 0-2.034.447-3.01 1.627.04.488.081.976.081 1.464v11.266h-6.588V38.127c0-2.806-1.383-4.148-3.539-4.148-1.017 0-1.993.488-2.969 1.749v12.608h-6.589V28.61h6.59v1.18c1.341-1.14 2.724-1.79 4.92-1.79 2.482 0 4.596.936 6.06 2.644C41.173 28.814 43.166 28 46.094 28z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          id="meilisearch_logo_svg__paint0_linear"
          x1={-10.62}
          y1={15.776}
          x2={16.372}
          y2={88.913}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E41359" />
          <stop offset={1} stopColor="#F23C79" />
        </linearGradient>
        <linearGradient
          id="meilisearch_logo_svg__paint1_linear"
          x1={2.926}
          y1={24.048}
          x2={23.756}
          y2={73.121}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#24222F" />
          <stop offset={1} stopColor="#2B2937" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default SvgMeilisearchLogo
